export enum HouseWorkType {
  Snowplowing = 'Snowplowing',
  Cleaning = 'Cleaning',
  Washing = 'Washing',
  Moving = 'Moving',
  Gardening = 'Gardening',
}
